export default __webpack_public_path__ + "static/media/underconstruc.240509f8.jpg";